<template>
  <div class="notice">
    <img class="banner clearfix" :src="bannerInfo.pic" alt="" />
    <div class="w flex" style="justify-content: space-between; height: 17rem">
      <div class="ban_l">
        <div class="tit">通知公告</div>
        <div class="desc" v-html="bannerInfo.content"></div>
      </div>
      <a-input-search
        :allowClear="true"
        style="width: 299px; margin-left: 20px"
        placeholder="请输入你要查询的关键字..."
        enter-button
        @search="onSearch"
      />
    </div>

    <!-- <div class="w notice_ti flex">
      <div class="title">通知公告 <span class="total">共{{total}}项</span></div>
    </div> -->

    <div class="w notic_content">
      <div class="notic_box">
        <div class="year_ul">
          <div :class="['year_li',idx == tabIdx ? 'year_li_class':'']" 
          v-for="(item,idx) in yearList" :key="idx" @click="yearChange(item,idx)">
            <span><em></em></span>
            {{item}}
          </div>
        </div>
        <div class="flex_r" v-for="(el,idx) in noticeList" :key="idx">
          <div class="month">{{el.time.substring(5,8)}}月</div>
          <div style="width: 100%">
            <div class="notice_list flex" v-for="item in el.list" :key="item.id">
              <div class="not_l">
                <!-- <div class="not_date">{{ item.time.substring(5, 10) }}</div> -->
                <div class="not_time" :style="el.list.length == 1?'padding-top:0':''">{{ item.time.substring(5, 10) }}</div>
              </div>
              <div class="not_r_box" :style="el.list.length == 1?'border-left:none':''">
                <div class="blue_yuan" :style="el.list.length == 1?'top:-5px':''"></div>
                <div class="not_r" :style="el.list.length == 1?'padding-top:0':''" @click="gotoDetails(item.id)">
                  <div class="not_title">{{ item.title }}</div>
                  <!-- <div class="not_con" v-html="item.content"></div> -->
                  <!-- <div class="check flex" @click="gotoDetails(item.id)">
                    <div>查看详情</div>
                    <img src="../../assets/icon/check.png" alt="" />
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="flex pagination_ w">
      <div class="total_">共 <span>{{total}}</span> 页 每页显示 10 条</div>
      <a-pagination
        v-model="current"
        :total="total"
        @change="pageChange"
      />
    </div>
  </div>
</template>

<script>
import { findNoticeByKeywordApi, findNoticeBannerApi, getYearOptionApi } from "@/api/index";
import { format } from "../../../utils/utils";
import imgPrefix from "../../../utils/imgPrefix";
export default {
  data() {
    return {
      noticeList: [],
      form: {},
      page: 1,
      pageSize: 10,
      total: 0,
      keyword: "",
      current: 1,
      imgPrefix,
      bannerInfo: {},
      yearList: [],
      tabIdx: 0,
      year: '',
      uniqueArr:[],
      list:[],
    };
  },
  created() {
    // 获取banner
    findNoticeBannerApi().then((res) => {
      // console.log(res);
      res.pic = this.imgPrefix + res.pic;
      this.bannerInfo = res;
    });
    getYearOptionApi().then(res => {
      this.yearList = res || [];
      this.year = res.length > 0 ? res[0] : ''
      this.getFindNotice();
    })
  },
  methods: {
    yearChange(year,idx) {
      this.tabIdx = idx;
      this.year = year;
      this.page = 1;
      this.getFindNotice()
    },
    // 获取公告列表
    getFindNotice() {
      let dto = {
        page: this.page,
        pageSize: this.pageSize,
        keyword: this.keyword,
        year: this.year
      };
      findNoticeByKeywordApi(dto)
        .then((res) => {
          // console.log(res);
          res.pageListVo.list.forEach((item) => {
            item.time = format(item.createTime, "yyyy-MM-dd");
          });
          let data = res.pageListVo.list;
          this.list = this.groupByYearMonth(data)
          // console.log(this.list,'this.list');          
          this.noticeList = this.getArrList();     
          console.log('this.noticeList',this.noticeList);
               
          this.total = res.pageListVo.total;
          this.current = res.pageListVo.page;
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    // 处理数组
  groupByYearMonth(arr){

    let uniqueArr = []
    let arr2 = []
    arr.map((current) => {
      const key = current.time.substring(0,7);
      arr2.push(key);
      uniqueArr = [...new Set(arr2)];//去重
    })
    this.uniqueArr = uniqueArr;

    // let newArr = []
    return arr.reduce((result, current) => {
      const key = current.time.substring(0,7);
      if (!result[key]) {
        result[key] = [];
      }
      // let obj = result[key].push(current);
      // // 将对象转为数组
      // Object.keys(obj).forEach(key => {
      //   newArr.push({ [key]: obj[key] });
      // });
      // return newArr;
      result[key].push(current);
      return result;
    }, {});
  },
  getArrList(){
    let arrList = []
    let obj = this.list;
    let arr = []
    Object.keys(obj).forEach(key => {
      arr.push({ [key]: obj[key] });
    });
    this.uniqueArr.map(item => {
      // 获取对象的键名
      for(let i of arr){
        // console.log(Object.keys(i),'Object.keys(i)-------');
        
        if(Object.keys(i)[0] == item){
          arrList.push({
            time: item,
            list: i[item],
          })
        }
      }
    })
    return arrList
  },
    onSearch(e) {
      this.page = 1;
      // console.log(e);
      this.keyword = e;
      this.getFindNotice();
    },
    gotoDetails(id) {
      this.$router.push("/noticeDetails?noticeId=" + id);
    },
    // 切换页码
    pageChange(page, pageSize) {
      // console.log(page, pageSize);
      this.page = page;
      this.getFindNotice();
    },
  },
};
</script>

<style scoped lang="less">
.notice {
  .banner {
    width: 100%;
    height: 17rem;
    text-align: left;
    position: absolute;
    left: 0;
    object-fit: cover; //保持原有尺寸比例。但部分内容可能被剪切。
  }
  .ban_l {
    margin-top: 0 !important;
  }
  // .ban_r {
  //   width: 43%;
  //   height: 272px;
  //   background: url("../../assets/banner-notice.png") no-repeat right;
  // }
  .notice_ti {
    justify-content: space-between;
    padding-bottom: 1%;
    margin-top: 3%;
  }
  .title {
    font-weight: 700;
    font-size: 28px;
    color: #0d1c28;
    text-align: left;
    .total {
      font-size: 18px;
      color: #7a8ba4;
      font-weight: 500;
    }
  }
  .notic_content{
    margin-bottom: 40px;
    margin-top: 56px;
    .notic_box {
      display: flex;
      .year_ul {
        min-width: 223px;
        margin-right: 47px;
        .year_li {
          padding: 25px;
          font-size: 20px;
          border-radius: 8px;
          border: 1px solid #e0e5f0;
          margin-bottom: 12px;
          color: #555;
          cursor: pointer;
        }
        .year_li_class {
          color: var(--themeColor);
          background: #E9EFF7;
          border: 1px solid var(--themeColor);
          position: relative;
          span {
            display: block;
            width: 0;
            height: 0;
            border-width: 10px 0 10px 10px;
            border-style: solid;
            border-color: transparent transparent transparent var(--themeColor);
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            right: -10px; 
          }
          em {
            display: block;
            width: 0;
            height: 0;
            border-width: 10px 0 10px 10px;
            border-style: solid;
            border-color: transparent transparent transparent #E9EFF7;
            position: absolute;
            top: -10px;
            left: -11px;
          }
        }
      }
      .flex_r{
        width: 100%;
        display: flex;
        padding-top: 40px;
        .month{
          font-size: 20px;
          color: #999;
          margin-right: 25px;
          line-height: 0;
          min-width: 45px;
        }
        .flex:first-child,
        .flex:last-child{
            align-items: normal;
          }
        .notice_list {
          .not_l {
            flex: 1;
            .not_date {
              font-size: 24px;
              font-weight: 700;
              color: var(--themeColor);
              margin-bottom: 8px;
            }
            .not_time {
              color: #7a8ba4;
            }
          }
          .not_r_box {
            flex: 9;
            border-left: 1px solid #e0e5f0;
            padding-left: 30px;
            position: relative;
            .blue_yuan {
              width: 12px;
              height: 12px;
              background: var(--themeColor);
              border-radius: 50%;
              position: absolute;
              left: -6px;
              top: 42%;
            }
          }
          .not_r {
            text-align: left;
            padding: 24px 0;
            border-bottom: 1px dashed #CECECE;
            cursor: pointer;
            .not_title {
              font-size: 16px;
              display: flex;
              flex-wrap: wrap;
            }
            .not_con {
              color: #7a8ba4;
              flex-wrap: wrap;
              overflow: hidden;
              -webkit-line-clamp: 2;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              margin: 16px 0 8px;
              max-height: 42px;
              image {
                height: 50px;
              }
            }
            .check {
              font-size: 14px;
              color: var(--themeColor);
              cursor: pointer;
              img {
                margin-left: 12px;
              }
            }
          }
          &:first-child .not_r{
            padding-top: 0;
            padding-bottom: 35px;
          }
          &:last-child .not_r{
            padding-bottom: 0;
            border-bottom: none;
            padding-top: 35px;
          }
          &:last-child .not_title,
          &:first-child .not_title{
            line-height: 0;
          }
          &:first-child .blue_yuan{
            top: -5px;
          } 
          &:last-child .blue_yuan{
            top: 80%;
          } 
          &:first-child .not_time{
            line-height: 2px;
          }
          &:last-child .not_time{
            line-height: 0;
            padding-top: 35px;
          }
        }
      }
    }
  }
  .pagination_{
    padding-bottom: 85px;
    justify-content: space-between;
    .total_{
      width: 145px;
      span{
        color: var(--themeColor);
      }
    }
  }
}
/deep/.ant-btn-primary {
  background: var(--themeSloganColor);
  border-color: var(--themeSloganColor);
  padding: 0 12px;
}
/deep/.ant-pagination {
  text-align: right;
}
</style>
